import React, {useEffect} from "react";
import styles from "./AboutPage.module.scss";
import SideBar from "../../components/sideBar/SideBar";
import useWindowSize from "../../hooks/useWindowSize";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import {useTranslation} from "react-i18next";
import GradientBackdrop from "../../components/shared/GradientBackdrop/GradientBackdrop";
import LinkGuide from "../../components/shared/LinkGuide/LinkGuide";
import { useLocation } from "react-router-dom";

const CooperationPage = () => {
  const { windowSize } = useWindowSize();
  const {t} = useTranslation();
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className={styles.wrapper}>
      <GradientBackdrop/>
      <Header className={styles.headerWrapper} />
      {windowSize !== "mobile" && <SideBar />}
      <div className={styles.container}>
        <div className={styles.titleWrapper}>
          <h2 className={styles.aboutTitle}>{t('Aboutus')}</h2>
          <p className={styles.sectionText}>
            {t('about1')}
          </p>
        </div>
        <div className={styles.sectionWrapper}>
          <p className={styles.sectionText}>
            {t('about2')}
          </p>
        </div>
        <div className={styles.sectionWrapper}>
          <p className={styles.sectionText}>
            {t('about3')}
          </p>
        </div>
        <div className={styles.sectionWrapper}>
          <p className={styles.sectionText}>
            {t('about4')}
          </p>
        </div>
      </div>
      <div style={{height: '50px'}} />
      <Footer source={''}/>
      <LinkGuide/>
    </div>
  );
};

export default CooperationPage;
